The role of the attachment within a profile.
